"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectBoxWrapper = exports.MultiSelectWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MultiSelectWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.MultiSelectBoxWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  cursor: pointer;

  > div > label {
    margin-right: 10px;
  }

  svg {
    position: relative;
    top: 5px;
  }
`;
//# sourceMappingURL=CheckboxMultiple.styles.js.map